/** API message when session is no longer valid; must stay in sync with backend. */
export const INVALID_AUTHENTICATION_MESSAGE =
  'Your authentication is invalid.' as const
